<div
  *ngIf="authorizeProvider !== AuthorizeProvider.myinfo_singpass; else singpass"
  (click)="login()"
  class="btn-sso-signin"
>
  <div class="p-2 mr-1">
    <img [src]="url" width="20px" height="auto" />
  </div>
  <div class="signin-text">{{ text }}</div>
</div>

<ng-template #singpass>
  <div class="singpass-container">
    <div (click)="signInWithSingpass()" class="singpass flex items-center">
      <div class="logo-container flex justify-end items-center">
        <mat-icon svgIcon="singpass-logo" class="singpass-logo"></mat-icon>
      </div>
      <button class="singpass-btn" mat-icon-button>
        <mat-icon svgIcon="singpass-btn" class="singpass-icon"></mat-icon>
      </button>
    </div>
  </div>
</ng-template>
